<template>
  <v-card class="decomposition">
    <v-scroll-x-transition>
      <v-card-text v-if="showDetails">
        <v-row>
          <v-col cols="6">
            <h3 class="decomposition_title">{{ detailInfo.subtitle }}</h3>
            <v-row class="mt-5" align="center">
              <v-col cols="12" class="d-flex align-center">
                <div class="arrow-box d-flex justify-center align-center" :class="`arrow-box_${detailInfo.arrow}`">
                  <mf-icon size="30" color="branco">{{ detailInfo.arrowIcon }}</mf-icon>
                </div>
                <h3 class="mb-0 pl-3 percentual-text percentual-text_minor" :class="`percentual-text_${detailInfo.arrow}`">
                  {{ detailInfo.period | localeString(2) }}%
                </h3>
              </v-col>
            </v-row>
            <v-row class="mt-5">
              <v-col cols="12">
                <div class="chip-box">
                  <v-row class="py-0 full-height" align="center">
                    <v-col cols="7">
                      <h5 class="mb-0 decomposition-subtitle dark-grey">Período atual</h5>
                      <p class="mb-0 light-grey">
                        {{ currentDate[0] | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }} a
                        {{ currentDate[1] | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}
                      </p>
                    </v-col>
                    <v-col class="d-flex justify-end" cols="5">
                      <h3 class="mb-0 decomposition-title">
                        <span v-if="detailInfo.currency">R$</span>
                        {{ detailInfo.current | localeString(2) }}
                      </h3>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="chip-box">
                  <v-row class="py-0 full-height" align="center">
                    <v-col cols="7">
                      <h5 class="mb-0 decomposition-subtitle dark-grey">Período referência</h5>
                      <p class="mb-0 light-grey">
                        {{ referencyDate[0] | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }} a
                        {{ referencyDate[1] | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}
                      </p>
                    </v-col>
                    <v-col class="d-flex justify-end" cols="5">
                      <h3 class="mb-0 decomposition-title">
                        <span v-if="detailInfo.currency">R$</span>
                        {{ detailInfo.referency | localeString(2) }}
                      </h3>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-card class="bg-cinza-l90" height="330">
              <v-card-title class="percentual-text_minor sky-blue">Ações</v-card-title>
              <v-card-text>
                <v-row v-if="actions.length > 0 && !loading" class="mx-5 center action-box_overflow">
                  <v-col v-for="(action, index) in actions" :key="index" cols="12" class="my-2 d-flex align-center action-box_item">
                    <p class="mb-0 decomposition-subtitle">{{ action.name }}</p>
                    <v-spacer />
                    <mf-button color="marca-0-l40" label="Saiba mais" @click="openActionModal(action)" />
                  </v-col>
                </v-row>
                <v-row v-else-if="loading" class="mx-5 center action-box_overflow">
                  <v-col v-for="index in [1, 2, 3, 4]" :key="index" cols="12" class="my-2 d-flex align-center action-box_item">
                    <v-skeleton-loader class="px-2" type="table-heading" width="100%" height="50" />
                  </v-col>
                </v-row>
                <v-row v-else class="mx-5 center action-box_overflow">
                  <v-col class="my-2 d-flex align-center action-box_item">
                    <p class="mb-0 decomposition-subtitle">Não há ações</p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card class="elevation-0 bg-cinza-l90">
          <v-card-title>
            <h3 class="decomposition_title">Detalhes</h3>
          </v-card-title>
          <v-card-text>
            <v-row class="pb-3">
              <v-col :cols="detailCols" class="py-0">
                <v-card height="290" class="elevation-0 card-border">
                  <decomposition-details-graphic
                    :graphicTitle="detailInfo.subtitle"
                    :units="units"
                    :detailIndicator="detailIndicator"
                    :units-configuration="unitsConfiguration"
                    :segments="segments"
                    :products="products"
                  />
                </v-card>
              </v-col>
              <v-col v-if="showClubCards" cols="4" class="py-0">
                <v-row>
                  <v-col cols="12" class="pt-0">
                    <v-card height="140" class="elevation-0 card-border">
                      <v-row class="full-height mx-0">
                        <v-col cols="4" lg="3" class="d-flex justify-center align-center">
                          <v-avatar size="60" color="marca-1">
                            <mf-icon color="branco" fill large> favorite </mf-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="8" lg="9" class="d-flex align-center">
                          <div>
                            <h3 class="mb-0 decomposition_detail-title text-bold">Clientes no Clube</h3>
                            <h4 class="mb-0 description">{{ detailInfo.subtitle }}</h4>
                            <h5 class="mb-0 small-text">{{ formatCurrentData }}</h5>
                            <h2 class="mb-0 percentual-text_minor text-bold">{{ detailInfo.clubValue | genericFormatter(valueFormatterConfiguration) }}</h2>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-card height="140" class="elevation-0 card-border">
                      <v-row class="full-height mx-0">
                        <v-col cols="4" lg="3" class="d-flex justify-center align-center">
                          <v-avatar size="60" color="marca-0">
                            <mf-icon color="branco" fill large> shopping_basket </mf-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="8" lg="9" class="d-flex align-center">
                          <div>
                            <h3 class="mb-0 decomposition_detail-title text-bold">{{ detailInfo.noClubCardTitle || 'Clientes fora do Clube' }}</h3>
                            <h4 class="mb-0 description">{{ detailInfo.noClubCardSubtitle || detailInfo.subtitle }}</h4>
                            <h5 class="mb-0 small-text">{{ formatCurrentData }}</h5>
                            <h2 class="mb-0 percentual-text_minor text-bold">{{ detailInfo.noClubValue | genericFormatter(valueFormatterConfiguration) }}</h2>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <decomposition-details-quick-actions
              :averageProducts="averageProducts"
              :averageItems="averageItems"
              :averageCoupons="averageCoupons"
              :detailIndicator="detailIndicator"
              :currentDate="currentDate"
              :referencyDate="referencyDate"
              :units="units"
              :units-configuration="unitsConfiguration"
              :segments="segments"
              :segments-object="segmentsObject"
              :products="products"
              :newSearch="showDetails"
            />
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-scroll-x-transition>
    <v-scroll-x-transition>
      <v-card-text v-if="!showDetails" style="height: 100%">
        <div style="height: 100%" class="d-flex justify-center align-center">
          <img height="612px" width="480px" :src="require('@/assets/empty_decomposition.png')" />
        </div>
      </v-card-text>
    </v-scroll-x-transition>
    <decomposition-details-actions-card v-model="openActions" :detailIndicator="detailIndicator" :action="action" />
  </v-card>
</template>

<script>
import { QUERY_GET_REVENUES_STRATEGIES, QUERY_GET_DETAILS } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  name: 'DecompositionDetails',
  components: {
    DecompositionDetailsGraphic: () => import('./DecompositionDetailsGraphic.vue'),
    DecompositionDetailsQuickActions: () => import('./DecompositionDetailsQuickActions.vue'),
    DecompositionDetailsActionsCard: () => import('./DecompositionDetailsActionsCard.vue'),
  },
  props: {
    showDetails: {
      type: Boolean,
      required: true,
    },
    detailIndicator: {
      type: String,
      required: true,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
    currentDate: {
      type: Array,
      required: true,
    },
    referencyDate: {
      type: Array,
      required: true,
    },
    units: {
      type: Array,
      default: () => [],
    },
    unitsConfiguration: {
      type: Array,
      default: () => [],
    },
    segments: {
      type: Array,
      default: () => [],
    },
    segmentsObject: {
      type: Array,
      default: () => [],
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    hasInfo: true,
    loading: false,
    openActions: false,
    averageCoupons: 0,
    averageProducts: 0,
    averageItems: 0,
    selectedDetail: '',
    dataGraphic: {},
    action: {},
    actions: [],
  }),
  computed: {
    valueFormatterConfiguration() {
      const currencyIndicators = ['AVERAGE_PRODUCT_VALUE']
      const integerIndicators = ['UNIQUE_CUSTOMERS']
      const formatter = { name: 'noop', hasLocaleString: true, localeStringDigits: 2 }
      if (currencyIndicators.includes(this.detailIndicator)) {
        formatter.name = 'currency'
      }
      if (integerIndicators.includes(this.detailIndicator)) {
        formatter.localeStringDigits = 0
      }
      return formatter
    },
    showClubCards() {
      const indicatorsWithClubCards = ['AVERAGE_ITEMS_IN_BASKET', 'AVERAGE_PRODUCT_VALUE', 'UNIQUE_CUSTOMERS']
      return indicatorsWithClubCards.includes(this.detailIndicator)
    },
    detailCols() {
      return this.showClubCards ? 8 : 12
    },
    formatCurrentData() {
      const initialDate = DateTime.fromISO(this.referencyDate[0], { locale: 'pt-br' }).toFormat('MMM yyyy')
      const finalDate = DateTime.fromSQL(this.currentDate[1], { locale: 'pt-br' }).toFormat('MMM yyyy')
      const formatText = `${initialDate} a ${finalDate}`

      return formatText.toUpperCase()
    },
  },
  watch: {
    detailIndicator() {
      if (this.showDetails && this.detailIndicator !== this.selectedDetail) {
        this.actions = []

        this.waitLoadDetails()
      }
      this.selectedDetail = this.detailIndicator
      this.averageProducts = this.detailInfo.averageProducts
      this.averageItems = this.detailInfo.averageItems
      this.averageCoupons = this.detailInfo.averageCoupons
    },
  },
  methods: {
    getDates() {
      const today = DateTime.now()
      const currentDate = today.toFormat('yyyy-MM-dd')
      const lastYearDate = today.minus({ year: 1 }).toFormat('yyyy-MM-dd')

      return { currentDate, lastYearDate }
    },
    async waitLoadDetails() {
      this.loading = true
      try {
        this.actions = await this.getDetailActions()
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: `Erro ao buscar os dados.` })
      }
      this.loading = false
    },
    getDetails() {
      return this.$apollo
        .query({
          query: QUERY_GET_DETAILS,
          variables: {
            initialDate: this.referencyDate[0],
            finalDate: this.referencyDate[1],
            referenceInitialDate: this.currentDate[0],
            referenceFinalDate: this.currentDate[1],
            units: this.units,
            units_configuration: this.unitsConfiguration,
            segments: this.segments,
            products: this.products,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => data)
        .catch((error) => {
          console.error(error)
          this.$snackbar({ message: `Erro ao buscar os dados.` })
        })
    },
    getDetailActions() {
      return this.$apollo
        .query({
          query: QUERY_GET_REVENUES_STRATEGIES,
          variables: {
            indicators: this.detailIndicator,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { revenueIncreaseStrategies } }) => {
          return revenueIncreaseStrategies
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
          this.$snackbar({ message: `Erro ao buscar os dados.` })
        })
    },
    openActionModal(action) {
      this.openActions = true
      this.action = action
    },
  },
}
</script>

<style lang="scss">
$text-bold: 700;

.chip-box {
  height: 80px;
  background-color: $cinza-l90 !important;
  border-radius: 10px;
  padding: 10px;
}
.action-box {
  &_item {
    height: 48px;
    background-color: $branco;
    border-radius: 10px;
  }
  &_overflow {
    overflow-y: auto;
    max-height: 250px;
  }
}
.sky-blue {
  color: $marca-0-l40;
}
.full-height {
  height: 100%;
}
.small-text {
  font-size: 8px;
}
.text-bold {
  font-weight: $text-bold;
}
.card-border {
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
}
.bg-cinza-l90 {
  background: $cinza-l90 !important;
}
</style>
